import { Pipe } from "@angular/core";

@Pipe({
  name: "commas",
})
export class CommaSeparatedPipe {
  transform(val) {
    if (val !== undefined && val !== null) {
      return val.toLocaleString();
    } else {
      return "";
    }
  }
}
